<template>
  <div :class="'menu-arealogada' + (hoverSubitem ? ' hover-arealogada' : '')">
    <div class="arealogada-meusdados">
      <h1>{{ name }}</h1>
      <h2>{{ email }}</h2>
      <b-link href="/cadastroUser" class="btn-arealogada-meusdados"
        >Meus dados</b-link
      >
      <b-link @click="downloadTermo" class="btn-arealogada-termodeuso mt-2"
        >Termo de uso</b-link
      >
      <div v-if="!loginGov" class="manter-logado-container d-flex mt-2 mb-2" :class="(manterLogado?' selected':'')" v-on:click="switchManterLogado">
        <span>Manter-me conectado</span>
        <b-form-checkbox
          class="manter-logado-selection" 
          v-model="manterLogado"
          size="lg"
          switch
        />
      </div>
    </div>
    <div class="arealogada-navigation-container">
      <div class="arealogada-card">
        <template v-for="(categoria, idx) in categoriasMenu">
          <div
            class="arealogada-card-categoria"
            v-if="(loginGov && categoria.nivelGov.includes(nivelGovUser)) || !loginGov"
          >
            <div class="arealogada-card-header" >
              <h3>{{ categoria.title }}</h3>
            </div>
            <div class="arealogada-card-body">
              <template v-for="(subCategoria, ix) in categoria.subCategorias">
                <div
                  v-if="(loginGov && subCategoria.nivelGov.includes(nivelGovUser)) || !loginGov"
                  class="arealogada-card-element"
                  @mouseenter="hoverSubitem = true"
                  @mouseleave="hoverSubitem = false"
                >
                  <b-link
                    :class=" 'arealogada-element-link' + (subCategoria.subitems.length > 0 ? ' arealogada-element-subitem' : '')"
                    :href="subCategoria.link"
                  >
                    <div :class="subCategoria.novidade ? 'novidade' : ''">{{ subCategoria.title }}</div>
                  </b-link>
                  <div class="arealogada-subitem-container" v-if="subCategoria.subitems.length > 0">
                  <template v-for="(subitem, i) in subCategoria.subitems">   
                    <b-link
                      v-if="(loginGov && subitem.nivelGov.includes(nivelGovUser)) || !loginGov"
                      class="arealogada-subitem-link"
                      :href="subitem.link"
                    >
                      {{ subitem.title }}
                    </b-link> 
                  </template> 
                    <!-- <b-link
                      class="arealogada-subitem-link"
                      :href="subitem.link"
                      v-for="(subitem, i) in subCategoria.subitems"
                      :key="i"
                      v-if="(loginGov && subitem.nivelGov.includes(nivelGovUser)) || !loginGov"
                      >{{ subitem.title }}</b-link
                    > -->
                  </div>
                </div>
              </template>
            </div>
          </div>
        </template>
      </div>
      <div class="arealogada-paraempresas">
        <h1>Para empresas</h1>
        <b-link
          href="/saiba-mais"
          class="btn-paraempresas"
          >Saiba mais</b-link
        >
      </div>
    </div>
  </div>
</template>
<script>
import { title } from "process";
import API from "../services/api";

export default {
  data() {
    return {
      name: "",
      email: "",
      show: true,
      toggle: false,
      toggle1: false,
      toggle2: false,
      toggle3: false,
      toggle4: false,
      libProcuracao: false,
      libAnuencia: false,
      permissaoConsulta: false,
      loginComCertificado: false,
      loginGov: false,
      servico_cancelamento: false,
      servico_anuencia: false,
      servico_certidao: false,
      servico_protesto: false,
      nivelGovUser: '',
      instrumento_protesto_cancelamento: false,
      exibe_subitem_envio: "none",
      exibe_subitem_anuencia: "none",
      exibe_subitem_certidao: "none",
      hoverSubitem: false,
      paraempresasBtnText: "Saiba mais",
      manterLogado: Boolean,
      categoriasMenu: [
        {
          title: "Protesto",
          subCategorias: [
            {
              title: "Consulta de CPF/CNPJ",
              link: "/servico/consulta-documento",
              subitems: [],
              nivelGov:['1','2','3'] // bronze / prata / ouro
            },
            {
              title: "Envio de Títulos",
              link: "#",
              subitems: [
                { title: "Novo pedido", link: "/PedidoProtesto", nivelGov:['2','3'] }, // bronze / prata / ouro
                { title: "Todos os pedidos",link: "/VisualizarPedidoProtesto",nivelGov:['2','3'] }, // bronze / prata / ouro
              ],
              nivelGov:['2','3'] // prata / ouro
            },
            {
              title: "Avise-me",
              link: "/avise-me",
              novidade:true,
              subitems: [],
             
              nivelGov:['2','3'] // prata / ouro
            },
            {
              title: "Verificação de Autenticidade",
              link: "/servico/autenticidade-protesto",
              subitems: [],
              nivelGov:['1','2','3'] // bronze / prata / ouro
            },
            {
              title: "Consulta de Títulos",
              link: "/ConsultaDeTitulos",
              subitems: [],
              nivelGov:['1','2','3'] // bronze / prata / ouro
            },
          ],
          nivelGov:['1','2','3'] // bronze / prata / ouro
        },
        {
          title: "Cancelamento de protesto",
          subCategorias: [
            {
              title: `Autorização de Cancelamento
            (Carta de anuência eletrônica)`,
              link: "#",
              subitems: [
                { title: "Novo pedido", link: "/anuenciaDigital", nivelGov:['3'] }, // bronze / prata / ouro
                { title: "Todos os pedidos", link: "/aprovadas", nivelGov:['3'] }, // bronze / prata / ouro
              ],
              nivelGov:['3'] // ouro
            },
            {
              title: `Pedido de Cancelamento`,
              link: "#",
              subitems: [{ title: "Todos os pedidos", link: "/cancelamento", nivelGov:['1','2','3'] }], // bronze / prata / ouro
              nivelGov:['1','2','3'] // bronze / prata / ouro
            },
          ],
          nivelGov:['1','2','3'] // bronze / prata / ouro
        },
        {
          title: "Edital Eletrônico",
          subCategorias: [
            {
              title: "Consulta de Edital",
              link: "/servico/consulta-edital",
              subitems: [],
              nivelGov:['1','2','3'] // bronze / prata / ouro
            },
            // { title:'Jornal Eletrônico', link:'#', subitems:[] },
          ],
          nivelGov:['1','2','3'] // bronze / prata / ouro
        },
        {
          title: "Certidão",
          subCategorias: [
            {
              title: "Pedido de certidão",
              link: "#",
              subitems: [
                { title: "Novo pedido", link: "/certidaoNegativa", nivelGov:['1','2','3'] },  // bronze / prata / ouro
                { title: "Todos os pedidos", link: "/pedidoCertidao", nivelGov:['1','2','3'] },  // bronze / prata / ouro 
              ],
              nivelGov:['1','2','3'] // bronze / prata / ouro
            },
            {
              title: "Verificação de autenticidade",
              link: "/servico/autenticidade-certidao",
              subitems: [],
              nivelGov:['1','2','3'] // bronze / prata / ouro
            },
          ],
          nivelGov:['1','2','3'] // bronze / prata / ouro
        },
      ],
    };
  },
  watch:{
    manterLogado(value){
      if(value) sessionStorage.setItem('keepAlive', value);
      else sessionStorage.removeItem('keepAlive');
    }
  },
  methods: {
    switchManterLogado(){
      this.manterLogado = !this.manterLogado;
      event.preventDefault();
    },
    go(section, route) {
      if (this.home && !route) {
        // eslint-disable-next-line
        fullpage_api.moveTo(section);
      } else {
        // volta para home -> seção
        this.$router.push({ name: section });
      }
    },
    downloadTermo: function () {
      this.loading = true;
      const token = localStorage.getItem("jwtToken");
      API.get("usuario/termo-aceite-site/resgata", { token })
        .then((res) => {
          //console.log(res.data.dados)
          const base64String = res.data.pdf; // your base64 string here
          const byteCharacters = atob(base64String);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: 'application/pdf' });
          const blobUrl = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = blobUrl;
          link.download = 'download_termo_aceite.pdf'; // the name of the file to download
          link.click();
        })
        .catch(() => {
          alert("Falha ao realizar o Download");
          this.loading = false;
        });
    },
    getPermicaoServico: function () {
      this.loading = true;
      const token = localStorage.getItem("jwtToken");
      API.post("usuario/getPermicaoServico", { token })
        .then((res) => {
          (this.servico_cancelamento =
            res.data[0].servico_cancelamento == 1 ? true : false),
            (this.servico_anuencia =
              res.data[0].servico_anuencia == 1 ? true : false),
            (this.servico_certidao =
              res.data[0].servico_certidao == 1 ? true : false),
            (this.servico_protesto =
              res.data[0].servico_protesto == 1 ? true : false);
        })
        .catch(() => {
          alert("Falha ao realizar o Download");
          this.loading = false;
        });
    },
  },
  beforeMount(){
    this.loginGov = this.$root.isLoggedGov();
    let keepAlive = sessionStorage.getItem('keepAlive');
    this.manterLogado = (keepAlive && keepAlive != undefined);
  },
  mounted() {
    if(this.loginGov) this.nivelGovUser = localStorage.getItem("lhwvzhds3");

    this.getPermicaoServico();
    this.name = localStorage.getItem("usrName");
    this.email = localStorage.getItem("usrEmail");
    //console.log(localStorage.getItem('libProcuracao'))
    this.libProcuracao = localStorage.getItem("libProcuracao");
    this.libAnuencia = localStorage.getItem("libAnuencia");
    this.instrumento_protesto_cancelamento = localStorage.getItem(
      "instrumento_protesto_cancelamento"
    );

    //alert(this.usr.name);
    const token = localStorage.getItem("jwtToken");

    let self = this;
    if (
      (localStorage.getItem("sg_tipo_documento") &&
        localStorage.getItem("SSL_CLIENT_S_DN_CN") &&
        localStorage.getItem("nm_tipo_certificado") &&
        localStorage.getItem("SSL_CLIENT_S_DN") &&
        localStorage.getItem("SSL_CLIENT_V_START") &&
        localStorage.getItem("SSL_CLIENT_V_END")) ||
      // && localStorage.getItem("usrCpf") != "17302278000116"
      process.env.VUE_APP_sitekeyRecaptcha == "6Lcq4tMUAAAAAIYTcaGCRhKxDG1B4ZyB__kG6X5j" || //homolog
      process.env.VUE_APP_sitekeyRecaptcha == "6LfV_cQUAAAAAA_ftGnzSww4O2OBEsdNAkQZWq2y" || //local
      localStorage.getItem("usrCpf") == "22055021826" // ou luiz paulo
    ) {
      this.permissaoConsulta = true;
      this.loginComCertificado = true;
    } else {
      API.post("titulos/permissaoConsulta", { token: token }).then((res) => {
        self.permissaoConsulta = res.data.permissaoConsulta;
        localStorage.setItem("diasVencimento", res.data.dias_restante);
      });
    }
    
    let keepAlive = sessionStorage.getItem('keepAlive');
    this.manterLogado = (keepAlive && keepAlive != undefined);
  },
};
</script>

<style>
.menu-arealogada {
  position: fixed;
  width: calc(296px + 5px + 5px);
  padding-left: 5px;
  padding-right: 5px;
  margin-top: 20px;
  padding-bottom: 72px;
  display: flex;
  flex-flow: column;
  z-index: 1;
  overflow-y: scroll;
  height: calc(100vh - 80px - 36px - 20px - 1px);
  scrollbar-width: none;
}
.menu-arealogada.hover-arealogada {
  width: calc(296px + 5px + 5px + 184px);
}
.menu-arealogada::-webkit-scrollbar {
  display: none;
}
.menu-arealogada .arealogada-meusdados {
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #c6c6c6;
  display: flex;
  flex-flow: column;
  width: 296px;
}
.menu-arealogada .arealogada-meusdados h1 {
  text-align: left;
  font-family: 'Kanit', sans-serif;
  font-size: 16px;
  font-weight: 200;
  letter-spacing: -1%;
  color: var(--secondary-color);
  margin-bottom: 10px;
  overflow: hidden;
  max-width: 295px;
  text-overflow: ellipsis;
}
.menu-arealogada .arealogada-meusdados h2 {
  text-align: left;
  font: normal normal normal 15px/17px 'Kanit', sans-serif;
  letter-spacing: -1%;
  color: #707070;
  margin-bottom: 20px;
}
.menu-arealogada .arealogada-meusdados .btn-arealogada-meusdados {
  width: 100%;
  height: 49px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  text-align: center;
  font-family: 'Kanit', sans-serif;
  font-size: 20px;
  font-weight: 400;
  letter-spacing: -1%;
  color: #ffffff;
  padding: 0;
  background: var(--primary-color) 0% 0% no-repeat padding-box;
  border: 3px solid var(--primary-color);
  border-radius: 40px;
}
.btn-arealogada-termodeuso:hover{text-decoration: none;color: #FFFFFF;}
.btn-arealogada-termodeuso{
  width: 100%;
  height: 49px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  text-align: center;
  font-family: 'Kanit', sans-serif;
  font-size: 20px;
  font-weight: 400;
  letter-spacing: -1%;
  color: #ffffff;
  padding: 0;
  background: var(--secondary-color) 0% 0% no-repeat padding-box;
  border: 3px solid var(--secondary-color);
  border-radius: 40px;
}
.menu-arealogada .arealogada-navigation-container {
  display: flex;
  flex-flow: column;
  width: 296px;
}
.menu-arealogada .arealogada-navigation-container .arealogada-card {
  display: flex;
  flex-flow: column;
  width: 100%;
  box-shadow: 0px 3px 6px #00000029;
  margin-bottom: 60px;
}
.menu-arealogada .arealogada-navigation-container .arealogada-card .arealogada-card-categoria {
  display: flex;
  flex-flow: column;
  width: 100%;
}
.menu-arealogada .arealogada-navigation-container .arealogada-card .arealogada-card-categoria .arealogada-card-header {
  display: flex;
  flex-flow: column;
  width: 100%;
  height: 40px;
  justify-content: center;
  align-items: center;
}
.menu-arealogada .arealogada-navigation-container .arealogada-card .arealogada-card-categoria:nth-child(1) .arealogada-card-header { background: #4780f1 0% 0% no-repeat padding-box; }
.menu-arealogada .arealogada-navigation-container .arealogada-card .arealogada-card-categoria:nth-child(2) .arealogada-card-header { background: #3791e7 0% 0% no-repeat padding-box; }
.menu-arealogada .arealogada-navigation-container .arealogada-card .arealogada-card-categoria:nth-child(3) .arealogada-card-header { background: #16b0d2 0% 0% no-repeat padding-box; }
.menu-arealogada .arealogada-navigation-container .arealogada-card .arealogada-card-categoria:nth-child(4) .arealogada-card-header { background: #1aceb5 0% 0% no-repeat padding-box; }
.menu-arealogada .arealogada-navigation-container .arealogada-card .arealogada-card-categoria:nth-child(5) .arealogada-card-header { background: #fe7d43 0% 0% no-repeat padding-box; }

.menu-arealogada .arealogada-navigation-container .arealogada-card .arealogada-card-categoria:nth-child(1) .arealogada-card-body .arealogada-card-element:hover > a.arealogada-element-link,  
.menu-arealogada .arealogada-navigation-container .arealogada-card .arealogada-card-categoria:nth-child(1) .arealogada-card-body .arealogada-card-element .arealogada-subitem-container a.arealogada-subitem-link:hover { background: #4780f1 0% 0% no-repeat padding-box; color:white !important;}
.menu-arealogada .arealogada-navigation-container .arealogada-card .arealogada-card-categoria:nth-child(2) .arealogada-card-body .arealogada-card-element:hover > a.arealogada-element-link, 
.menu-arealogada .arealogada-navigation-container .arealogada-card .arealogada-card-categoria:nth-child(2) .arealogada-card-body .arealogada-card-element .arealogada-subitem-container a.arealogada-subitem-link:hover { background: #3791e7 0% 0% no-repeat padding-box; color:white !important;}
.menu-arealogada .arealogada-navigation-container .arealogada-card .arealogada-card-categoria:nth-child(3) .arealogada-card-body .arealogada-card-element:hover > a.arealogada-element-link, 
.menu-arealogada .arealogada-navigation-container .arealogada-card .arealogada-card-categoria:nth-child(3) .arealogada-card-body .arealogada-card-element .arealogada-subitem-container a.arealogada-subitem-link:hover { background: #16b0d2 0% 0% no-repeat padding-box; color:white !important;}
.menu-arealogada .arealogada-navigation-container .arealogada-card .arealogada-card-categoria:nth-child(4) .arealogada-card-body .arealogada-card-element:hover > a.arealogada-element-link, 
.menu-arealogada .arealogada-navigation-container .arealogada-card .arealogada-card-categoria:nth-child(4) .arealogada-card-body .arealogada-card-element .arealogada-subitem-container a.arealogada-subitem-link:hover { background: #1aceb5 0% 0% no-repeat padding-box; color:white !important;}
.menu-arealogada .arealogada-navigation-container .arealogada-card .arealogada-card-categoria:nth-child(5) .arealogada-card-body .arealogada-card-element:hover > a.arealogada-element-link, 
.menu-arealogada .arealogada-navigation-container .arealogada-card .arealogada-card-categoria:nth-child(5) .arealogada-card-body .arealogada-card-element .arealogada-subitem-container a.arealogada-subitem-link:hover { background: #fe7d43 0% 0% no-repeat padding-box; color:white !important;}


.menu-arealogada .arealogada-navigation-container .arealogada-card .arealogada-card-categoria .arealogada-card-header h3 {
  text-align: center;
  font-family: 'Kanit', sans-serif;
  font-size: 16px;
  font-weight: 200;
  letter-spacing: -1%;
  color: #ffffff !important;
  margin: 0;
}
.menu-arealogada
  .arealogada-navigation-container
  .arealogada-card
  .arealogada-card-body {
  display: flex;
  flex-flow: column;
  width: 100%;
}

.menu-arealogada .arealogada-navigation-container .arealogada-card .arealogada-card-categoria .arealogada-card-body .arealogada-card-element { width: 100%; height: fit-content; display: flex; align-items: flex-start }
.menu-arealogada .arealogada-navigation-container .arealogada-card .arealogada-card-categoria .arealogada-card-body .arealogada-card-element:hover > .arealogada-subitem-container { display: flex }

/* .menu-arealogada .arealogada-navigation-container .arealogada-card .arealogada-card-categoria .arealogada-card-body .arealogada-card-element:hover > a.arealogada-element-link,
.menu-arealogada .arealogada-navigation-container .arealogada-card .arealogada-card-categoria .arealogada-card-body .arealogada-card-element .arealogada-subitem-container a.arealogada-subitem-link:hover { background-color: #597eb5; color: white !important } */

.menu-arealogada
  .arealogada-navigation-container
  .arealogada-card
  .arealogada-card-categoria
  .arealogada-card-body
  .arealogada-card-element:hover
  > a.arealogada-element-link.arealogada-element-subitem::after {
  border-left: 5px solid white;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
}
.menu-arealogada
  .arealogada-navigation-container
  .arealogada-card
  .arealogada-card-categoria
  .arealogada-card-body
  .arealogada-card-element:not(:last-child) {
  border-bottom: 1px solid var(--secondary-color);
}

.menu-arealogada
  .arealogada-navigation-container
  .arealogada-card
  .arealogada-card-categoria
  .arealogada-card-body
  .arealogada-card-element
  a.arealogada-element-link {
  width: 100%;
  text-align: center;
  font-family: 'Kanit', sans-serif;
  font-size: 16px;
  font-weight: 200;
  letter-spacing: -1%;
  color: var(--secondary-color);
  padding: 10px 0;
  display: flex;
  text-decoration: none;
  align-items: center;
  justify-content: center;
  white-space: pre-line;
}
.menu-arealogada
  .arealogada-navigation-container
  .arealogada-card
  .arealogada-card-categoria
  .arealogada-card-body
  .arealogada-card-element
  a.arealogada-element-link.arealogada-element-subitem::after {
  content: "";
  width: 10px;
  height: 10px;
  border-left: 5px solid var(--secondary-color);
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  position: absolute;
  left: 289px;
}

.menu-arealogada
  .arealogada-navigation-container
  .arealogada-card
  .arealogada-card-categoria
  .arealogada-card-body
  .arealogada-card-element
  .arealogada-subitem-container {
  width: 184px;
  background-color: white;
  display: none;
  flex-flow: column;
  position: absolute;
  left: 301px;
  box-shadow: 3px 3px 6px #00000029;
}

.menu-arealogada
  .arealogada-navigation-container
  .arealogada-card
  .arealogada-card-categoria
  .arealogada-card-body
  .arealogada-card-element
  .arealogada-subitem-container
  a.arealogada-subitem-link {
  width: 100%;
  text-align: center;
  font-family: 'Kanit', sans-serif;
  font-size: 16px;
  font-weight: 200;
  letter-spacing: -1%;
  color: var(--secondary-color);
  text-decoration: none;
  padding: 10px 0;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  white-space: pre-line;
  height: 45px;
  padding: 0;
  align-content: center;
  line-height: 2px;
}
.menu-arealogada
  .arealogada-navigation-container
  .arealogada-card
  .arealogada-card-categoria
  .arealogada-card-body
  .arealogada-card-element
  .arealogada-subitem-container
  a.arealogada-subitem-link:not(:last-child) {
  border-bottom: 1px solid var(--secondary-color);
}

.menu-arealogada .arealogada-navigation-container .arealogada-paraempresas {
  border-top: 1px solid #c6c6c6;
  padding-top: 12px;
  width: 100%;
  display: flex;
  flex-flow: column;
}
.menu-arealogada .arealogada-navigation-container .arealogada-paraempresas h1 {
  text-align: left;
  font-family: 'Kanit', sans-serif;
  font-size: 20px;
  font-weight: 300;
  letter-spacing: -1%;
  color: var(--secondary-color);
  letter-spacing: -1%;
  color: #597eb5;
}
.menu-arealogada
  .arealogada-navigation-container
  .arealogada-paraempresas
  .btn-paraempresas {
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 49px;
  width: 100%;
  border: none;
  border-radius: 40px;
  text-align: center;
  font-family: 'Kanit', sans-serif;
  font-size: 20px;
  font-weight: 400;
  letter-spacing: -1%;
  color: #ffffff;
  background-color: var(--primary-color);
}
.menu-arealogada
  .arealogada-navigation-container
  .arealogada-paraempresas
  .btn-paraempresas
  img {
  height: 15px;
  width: 15px;
  position: absolute;
  left: 90px;
}
.novidade {
  /* position: relative; */
  /*padding-left: 25px; */ /* Espaço para o ícone */
}
.novidade::before {
  /* content: "\2605"; */ /* Código unicode da estrela vazia */
  position: absolute;
  /* left: 0; */
  /* top: 0; */
  font-size: 20px; /* Tamanho do ícone */
  /* color: #f39c12; */ /* Cor do ícone */
  content: 'NOVIDADE';
  color: #ffffff;
  background-color: #e8570e;
  border-radius: 5px;
  padding: 2px 7px 3px 7px;
  font: normal normal bold 8px/10px 'Kanit', sans-serif;
  /* margin-left: -61px; */
  margin-top: 3px;
  left: 14px;
}
.manter-logado-container {
  transition: all 0.3s ease;
  align-items:center;
  justify-content: flex-end;
  height: 49px;
  cursor:pointer;
  user-select: none;
  border: 3px solid var(--primary-color);;
  background: #fff;
  border-radius: 40px;
}
.manter-logado-container:hover,
.manter-logado-container.selected{
  background: var(--primary-color);;
}
.manter-logado-container span{
  transition: all 0.3s ease;
  text-align: center;
  font-family: 'Kanit', sans-serif;
  font-size: 20px;
  font-weight: 400;
  letter-spacing: -1%;
  color: var(--primary-color);
  width: 100%;
}
.manter-logado-container:hover span,
.manter-logado-container.selected span{
  color: #fff;
}
.manter-logado-container .manter-logado-selection{
  margin-top: -4px;
}
</style>
